const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-605,-226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Forma-1",
    serifId: "Forma 1",
    d: "M618,226C610.831,226 605,231.831 605,239C605,246.168 610.831,252 618,252C625.168,252 631,246.168 631,239C631,231.831 625.168,226 618,226ZM618,251C611.383,251 606,245.616 606,239C606,232.383 611.383,227 618,227C624.616,227 630,232.383 630,239C630,245.616 624.616,251 618,251ZM618,244.5C617.723,244.5 617.5,244.723 617.5,245L617.5,246C617.5,246.276 617.723,246.5 618,246.5C618.276,246.5 618.5,246.276 618.5,246L618.5,245C618.5,244.723 618.276,244.5 618,244.5ZM618.056,230.5C618.037,230.5 618.018,230.5 617.999,230.5C616.941,230.5 615.946,230.907 615.191,231.652C614.423,232.409 614,233.421 614,234.5C614,234.776 614.223,235 614.5,235C614.776,235 615,234.776 615,234.5C615,233.691 615.317,232.932 615.893,232.364C616.47,231.795 617.237,231.481 618.043,231.5C619.623,231.522 620.977,232.876 620.999,234.457C621.014,235.499 620.5,236.458 619.624,237.023C618.294,237.881 617.5,239.397 617.5,241.079L617.5,242.5C617.5,242.776 617.723,243 618,243C618.276,243 618.5,242.776 618.5,242.5L618.5,241.079C618.5,239.758 619.138,238.526 620.166,237.863C621.333,237.11 622.019,235.831 621.999,234.443C621.969,232.299 620.2,230.53 618.056,230.5Z",
    style: {
      fill: "rgb(173,53,33)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.5ef1e558eaad1df61e21ae3c20f11614.svg";
export { ForwardRef as ReactComponent };